<template>
  <AdminMainViewWithAppBar v-if="isAdmin" />
  <CustomerMainViewWithAppBar v-else />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useAuthStore } from "@/store/AuthStore";
import AdminMainViewWithAppBar from "@/views/admin/AdminMainViewWithAppBar.vue";
import CustomerMainViewWithAppBar from "@/views/customer/CustomerMainViewWithAppBar.vue";

/**
 * The app shell for a route that is not tied to either portal — today, the catch-all.
 *
 * It picks the shell from the signed-in user's role rather than from the URL, which matters
 * because the catch-all also renders a customer who wandered onto an /admin/... URL: showing
 * them the admin navigation would be both useless and a needless map of a portal they cannot
 * open. They get their own nav, at the URL they asked for.
 */
const authStore = useAuthStore();
const isAdmin = computed(() => authStore.isAdmin);
</script>
